module.exports = __webpack_public_path__ + "img/u24.0924c9a5.png";